namespace GeniuzPOS.Administration {
    export interface PsParaForm {
        Id: Serenity.IntegerEditor;
        ShopName: Serenity.StringEditor;
        BranchName: Serenity.StringEditor;
        ShopAddress: Serenity.StringEditor;
        ShopRegName: Serenity.StringEditor;
        ShopRegAddressLine1: Serenity.StringEditor;
        ShopRegAddressLine2: Serenity.StringEditor;
        ShopRegAddressLine3: Serenity.StringEditor;
        ShopTaxId: Serenity.StringEditor;
        ShopRegId: Serenity.StringEditor;
        ChargeVatRate: Serenity.DecimalEditor;
        PointRedeemOneBaht: Serenity.DecimalEditor;
        PosProcessMode: Serenity.RadioButtonEditor;
        PosScreenType: Serenity.RadioButtonEditor;
        DiscRoundMethod: Serenity.EnumEditor;
        PromptPayLink: Serenity.StringEditor;
        QRCodeAccount: Serenity.StringEditor;
        AllowSaleOverStock: Serenity.EnumEditor;
        CountLockSignInWrongPassInDay: Serenity.IntegerEditor;
        BackOfficeUpLoadURL: Serenity.StringEditor;
        ShopLogoOnFrontScreen: Serenity.ImageUploadEditor;
        ShopLogoOnReceipt: Serenity.ImageUploadEditor;
        RecptHeadMesgFontSize: Serenity.StringEditor;
        RecptHeadMesgTextAlign: Serenity.RadioButtonEditor;
        RecptHeadMesg1: Serenity.StringEditor;
        RecptHeadMesg2: Serenity.StringEditor;
        RecptHeadMesg3: Serenity.StringEditor;
        RecptHeadMesg4: Serenity.StringEditor;
        RecptHeadMesg5: Serenity.StringEditor;
        RecptHeadMesg6: Serenity.StringEditor;
        RecptFootMesgFontSize: Serenity.StringEditor;
        RecptFootMesgTextAlign: Serenity.RadioButtonEditor;
        RecptFootMesg1: Serenity.StringEditor;
        RecptFootMesg2: Serenity.StringEditor;
        RecptFootMesg3: Serenity.StringEditor;
        RecptFootMesg4: Serenity.StringEditor;
        RecptFootMesg5: Serenity.StringEditor;
        RecptFootMesg6: Serenity.StringEditor;
        RecptFootMesg7: Serenity.StringEditor;
        RecptFootMesg8: Serenity.StringEditor;
        RecptFootMesg9: Serenity.StringEditor;
        RecptFootMesg10: Serenity.StringEditor;
        RecptNoBarcodeFg: Serenity.EnumEditor;
        SalesVatType: Serenity.RadioButtonEditor;
        SelectSellingPriceFg: Serenity.EnumEditor;
        ReceiptPrinterType: Serenity.EnumEditor;
        EjournalFg: Serenity.EnumEditor;
        RecptSumItemQtyFg: Serenity.EnumEditor;
        NoOfRecptCopy: Serenity.IntegerEditor;
        SalesDocFg: Serenity.EnumEditor;
        PrintOrderFg: Serenity.EnumEditor;
        PrintQueueFg: Serenity.EnumEditor;
        ItemOnRecptMethod: Serenity.EnumEditor;
        TaxInvoiceDateFg: Serenity.IntegerEditor;
    }

    export class PsParaForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PsPara';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsParaForm.init)  {
                PsParaForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = s.EnumEditor;
                var w5 = s.ImageUploadEditor;

                Q.initFormType(PsParaForm, [
                    'Id', w0,
                    'ShopName', w1,
                    'BranchName', w1,
                    'ShopAddress', w1,
                    'ShopRegName', w1,
                    'ShopRegAddressLine1', w1,
                    'ShopRegAddressLine2', w1,
                    'ShopRegAddressLine3', w1,
                    'ShopTaxId', w1,
                    'ShopRegId', w1,
                    'ChargeVatRate', w2,
                    'PointRedeemOneBaht', w2,
                    'PosProcessMode', w3,
                    'PosScreenType', w3,
                    'DiscRoundMethod', w4,
                    'PromptPayLink', w1,
                    'QRCodeAccount', w1,
                    'AllowSaleOverStock', w4,
                    'CountLockSignInWrongPassInDay', w0,
                    'BackOfficeUpLoadURL', w1,
                    'ShopLogoOnFrontScreen', w5,
                    'ShopLogoOnReceipt', w5,
                    'RecptHeadMesgFontSize', w1,
                    'RecptHeadMesgTextAlign', w3,
                    'RecptHeadMesg1', w1,
                    'RecptHeadMesg2', w1,
                    'RecptHeadMesg3', w1,
                    'RecptHeadMesg4', w1,
                    'RecptHeadMesg5', w1,
                    'RecptHeadMesg6', w1,
                    'RecptFootMesgFontSize', w1,
                    'RecptFootMesgTextAlign', w3,
                    'RecptFootMesg1', w1,
                    'RecptFootMesg2', w1,
                    'RecptFootMesg3', w1,
                    'RecptFootMesg4', w1,
                    'RecptFootMesg5', w1,
                    'RecptFootMesg6', w1,
                    'RecptFootMesg7', w1,
                    'RecptFootMesg8', w1,
                    'RecptFootMesg9', w1,
                    'RecptFootMesg10', w1,
                    'RecptNoBarcodeFg', w4,
                    'SalesVatType', w3,
                    'SelectSellingPriceFg', w4,
                    'ReceiptPrinterType', w4,
                    'EjournalFg', w4,
                    'RecptSumItemQtyFg', w4,
                    'NoOfRecptCopy', w0,
                    'SalesDocFg', w4,
                    'PrintOrderFg', w4,
                    'PrintQueueFg', w4,
                    'ItemOnRecptMethod', w4,
                    'TaxInvoiceDateFg', w0
                ]);
            }
        }
    }
}
